import {
  getColorClassNames,
  cx,
  colorPalette,
  Color,
  IconVariant,
  getLightDarkColorClassNames,
} from '@UI/lib/utils';

export type WrapperProportionTypes = {
  paddingX: string;
  paddingY: string;
};

export const wrapperProportions: { [size: string]: WrapperProportionTypes } = {
  xs: {
    paddingX: 'px-1.5',
    paddingY: 'py-1.5',
  },
  sm: {
    paddingX: 'px-1.5',
    paddingY: 'py-1.5',
  },
  md: {
    paddingX: 'px-2',
    paddingY: 'py-2',
  },
  lg: {
    paddingX: 'px-2',
    paddingY: 'py-2',
  },
  xl: {
    paddingX: 'px-2.5',
    paddingY: 'py-2.5',
  },
};

export const iconSizes: {
  [size: string]: {
    height: string;
    width: string;
  };
} = {
  xs: {
    height: 'h-3',
    width: 'w-3',
  },
  sm: {
    height: 'h-4',
    width: 'w-4',
  },
  md: {
    height: 'h-5',
    width: 'w-5',
  },
  lg: {
    height: 'h-7',
    width: 'w-7',
  },
  xl: {
    height: 'h-9',
    width: 'w-9',
  },
};

export type ShapeTypes = {
  rounded: string;
  border: string;
  ring: string;
  shadow: string;
};

export const shape: { [style: string]: ShapeTypes } = {
  simple: {
    rounded: '',
    border: '',
    ring: '',
    shadow: '',
  },
  light: {
    rounded: 'rounded-revving-default',
    border: '',
    ring: '',
    shadow: '',
  },
  shadow: {
    rounded: 'rounded-revving-default',
    border: 'border',
    ring: '',
    shadow: 'shadow-revving-card dark:shadow-dark-revving-card',
  },
  solid: {
    rounded: 'rounded-revving-default',
    border: 'border-2',
    ring: 'ring-1',
    shadow: '',
  },
  outlined: {
    rounded: 'rounded-revving-default',
    border: 'border',
    ring: 'ring-2',
    shadow: '',
  },
};

export const getIconColors = (variant: IconVariant, color?: Color) => {
  switch (variant) {
    case 'simple':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        bgColor: '',
        borderColor: '',
        ringColor: '',
      };
    case 'light':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        bgColor: color
          ? cx(
              getColorClassNames(color, colorPalette.background).bgColor,
              'bg-opacity-20 dark:bg-opacity-40',
            )
          : 'bg-revving-brand-muted dark:bg-darkRevving-brand-muted',
        borderColor: '',
        ringColor: '',
      };
    case 'shadow':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        bgColor: 'bg-revving-background dark:bg-darkRevving-background',
        borderColor: 'border-revving-border dark:border-darkRevving-border',
        ringColor: '',
      };
    case 'solid':
      return {
        textColor: color
          ? getLightDarkColorClassNames('text', color, 50, 950)
          : 'text-revving-brand-inverted dark:text-darkRevving-brand-inverted',
        bgColor: color
          ? cx(getColorClassNames(color, colorPalette.background).bgColor)
          : 'bg-revving-brand dark:bg-darkRevving-brand',
        borderColor:
          'border-revving-brand-inverted dark:border-darkRevving-brand-inverted',
        ringColor: 'ring-revving-ring dark:ring-darkRevving-ring',
      };
    case 'outlined':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        bgColor: 'bg-revving-background dark:bg-darkRevving-background',
        borderColor: color
          ? getColorClassNames(color, colorPalette.ring).borderColor
          : 'border-revving-brand-subtle dark:border-darkRevving-brand-subtle',
        ringColor: color
          ? cx(
              getColorClassNames(color, colorPalette.ring).ringColor,
              'ring-opacity-40',
            )
          : 'ring-revving-brand-muted dark:ring-darkRevving-brand-muted',
      };
  }
};
